export default __webpack_public_path__ + "static/media/home-banner.38207416.png";